export enum BridgeRoomMessageType {
	Default = 'default',
	Modal = 'modal',
}

export interface BridgeRoomMessageStep {
	title?: string;
	text: string;
	image?: string;
	button_text?: string;
	text_align?: string;
}

export interface BridgeRoomMessage {
	type: BridgeRoomMessageType;
	title?: string;
	text?: string;
	button_text?: string;
	image?: string;
	steps: BridgeRoomMessageStep[];
	message_type?: string;
}

export enum EpisodeStatus {
	Completed = 'completed',
	Active = 'active',
	Locked = 'locked',
}

export enum LockerComputerModalVariant {
	NewLetters = 'new-letters',
	FillPassword = 'fill-password',
}

export interface BridgeEpisodeHint {
	position: number;
	content: string | null;
	revealed: boolean;
	new: boolean;
}

export interface BridgeEpisode {
	id: number;
	name: string;
	unlocked_at: string | null;
	days_until_unlock: number | null;
	days_until_unlock_text: string | null;
	locked_status_text: string | null;
	hints: BridgeEpisodeHint[];
	default_room_image: string;
	default_room_name: string;
	status: EpisodeStatus;
	locker_unlocked: boolean;
	agenda_page_image_desktop: Record<string, string>;
	agenda_page_image_mobile: string;
	agenda_page_image_state: string;
}

export interface BridgeMessengerMessage {
	text: string;
	image_url?: string;
}

export interface BridgeMessenger {
	id: number;
	type: string;
	messages: BridgeMessengerMessage[];
}

export interface BridgeTask {
	id: number;
	name: string;
	episode_name?: string;
	nl_type?: string;
	image?: string;
	color?: string;
	type: string;
	status?: string | null;
}

export interface BridgeTaskDetail {
	id: number;
	name: string;
	type: string;
	image?: string | null;
	description?: string | null;
	video_url?: string | null;
	secondary_button_url?: string | null;
	primary_button_text?: string | null;
	secondary_button_text?: string | null;
	modal_title?: string | null;
	modal_description?: string | null;
	modal_image?: string | null;
	questions?: Array<{ id: number }>;
	[key: string]: unknown;
}

export interface BridgeRoomDoor {
	image?: string;
	room_id: number;
	room_type: string;
	position: 'top' | 'bottom' | 'left' | 'right';
	status: 'open' | 'closed';
	tooltip_text?: string;
}

export interface BridgeRoom {
	id: number;
	name: string;
	type: string;
	tasks: BridgeTask[];
	doors: BridgeRoomDoor[];
	messages?: BridgeRoomMessage[];
	messengers?: BridgeMessenger[];
}

export interface BridgeTaskResultModalData {
	subtitle?: string | null;
	title?: string | null;
	text?: string | null;
	image?: string | null;
	primary_button_text?: string | null;
	secondary_button_text?: string | null;
}

export interface LockerAgendaData {
	title: string;
	description: string;
	imageUrl: string;
}

export type BridgeDoorPosition = 'top' | 'bottom' | 'left' | 'right';

export interface BridgeMapDoorData {
	room_id: number | null;
	room_type: string;
	position: BridgeDoorPosition;
	image?: string | null;
}

export interface BridgeMapRoomData {
	id: number;
	name: string;
	room_type: string;
	image: string;
	background_image: string;
	status: 'open' | 'closed';
	doors: BridgeMapDoorData[] | null;
	tooltip_text: string | null;
}

export interface BridgeMapFloor {
	floor_type: string;
	name: string;
	rooms: BridgeMapRoomData[];
}

export interface BridgeMapData {
	current_room_id: number;
	floors: BridgeMapFloor[];
}

export type BridgeMap = BridgeMapData;

export interface BridgeGameState {
	episodes: BridgeEpisode[];
	episodesLoading: boolean;
	loading: boolean;
	room: BridgeRoom | null;
	error: string | null;
	task: BridgeTaskDetail | null;
	taskLoading: boolean;
	taskVersion: number;
	lockerComputerModal: LockerComputerModalVariant | null;
	lockerPasswordError: string | null;
	lockerAgendaModal: boolean;
	lockerAgendaData: LockerAgendaData | null;
	roomDialogMessages: BridgeRoomMessage[] | null;
	taskFinishResult: BridgeTaskResultModalData | null;
	resumeRoomId: number | null;
	shouldResumePlayerPosition: boolean;
	map: BridgeMap | null;
	mapLoading: boolean;
}
